import React from 'react';
import classNames from 'classnames';
import s from '#components/navigation/tabs/tabsItem/tabsItem.module.scss';

type Props = {
  id: number | string;
  index?: number;
  text: string;
  count?: number; // Show count if `count` is not undefined
  ariaSelected?: boolean;
  isButtonStyle?: boolean;
  handleOnClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

const TabsItem = (props: Props) => {
  const { id, text, count, handleOnClick, ariaSelected, isButtonStyle } = props;

  const blockClass = classNames(s.host, {
    [s.isButtonStyle]: !!isButtonStyle,
  });

  return (
    <li className={blockClass} data-block="tabsItem">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus */}
      <a
        className={s.inner}
        role="tab"
        id={`content-tab-${id}`}
        onClick={handleOnClick}
        aria-selected={ariaSelected}
      >
        {text}
        {(count === 0 || count > 0) && ` (${count})`}
      </a>
    </li>
  );
};

export default TabsItem;
